import { Link } from "gatsby";
import React, { FunctionComponent } from "react";
import { getLocalizedUrl } from "../../utils/localeURL";
import PuxWysiwyg from "../contentTypes/PuxWysiwyg/PuxWysiwyg";
import SubscribeForm from "../zoho/SubscribeForm";
import { FooterData, IFooterData } from "Root/src/queries/layout-queries";

interface FooterPropsType {
  footerData: IFooterData;
}

const Footer: FunctionComponent<FooterPropsType> = (props) => {
  const footerData: FooterData = props.footerData.salmonSoftwareFooter[0]
  return (
    <footer className="Footer">
      <div className="pux-cotainer pux-container-fluid">
        <div className="Footer-grid">
          <div className="Footer-content">
            <PuxWysiwyg content={footerData.footerContent ?? { html: "" }} />
          </div>

          <div className="Footer-menu">
            <h2>Site map</h2>
            <ul>
              {footerData.footerMenu.contentItems.map((menuItem, idx) => (
                <li key={idx}>
                  {menuItem.linkItemLink?.contentItems[0] !== null && menuItem.linkItemLink?.contentItems[0]?.path.startsWith("http") &&
                    <a href={menuItem.linkItemLink?.contentItems[0]?.path.includes("/homepage") ? "/" : menuItem.linkItemLink?.contentItems[0]?.path}>{menuItem.displayText}</a> 
                  }
                  {menuItem.linkItemLink?.contentItems[0] !== null && !menuItem.linkItemLink?.contentItems[0]?.path.startsWith("http") &&
                    <Link to={menuItem.linkItemLink?.contentItems[0]?.path.includes("/homepage") ? "/" : getLocalizedUrl(menuItem.linkItemLink?.contentItems[0]?.path)}>{menuItem.displayText}</Link>
                  }
                </li>
              ))}
            </ul>
          </div>

          <div className="Footer-subscribe">
            <SubscribeForm />
            <h2>Follow us on social media</h2>
            <ul className="Social-links">
              {footerData.footerSocials.contentItems?.map((social, idx) => (
                <li key={idx}>
                  <a target={"_blank"} className={`Social-logo ${social.socialType}`} href={social.socialLink}></a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="Footer-copyright">
          &copy; Salmon Software{" "}
          <span className="year">{new Date().getFullYear()}</span> /{" "}
          <a href="https://puxdesign.cz/cz">Webdesign</a> by PUXdesign
        </div>
      </div>
    </footer>
  );
};

export default Footer;
